import { z } from "zod";
import { meetingTypeCode } from "./bookingMeetingTypes";

// HH:mm
export const slotTime = z
  .string()
  .regex(/^([01][0-9]|[2][0123]):([0-5][0-9])$/);

const timeSlot = z.object({
  date: z.iso.date(), // yyyy-MM-dd
  slotTimes: z.array(slotTime),
});

export type TimeSlot = z.infer<typeof timeSlot>;

const meetingType = z.object({
  meetingTypeId: z.string(),
  meetingTypeCode: meetingTypeCode,
  minDate: z.iso.date(),
  maxDate: z.iso.date(),
  dates: z.array(timeSlot),
});

export type BookingSlot = z.infer<typeof meetingType>;

export const bookingSlots = z.object({
  meetingTypes: z.array(meetingType),
});

export type BookingSlots = z.infer<typeof bookingSlots>;
